import { AccountsTable } from './sub-account/AccountsTable.tsx';
import { usePartnerSubAccountCreation } from '../../hooks/usePartnerSubAccountCreation.ts';
import SetupRequired from './sub-account/SetupRequired.tsx';

function SubAccountsManager() {
  const { isWhiteLabel, canCreateSubAccounts, isLoading: isLoadingSubAccountCreation } = usePartnerSubAccountCreation();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Sub-Accounts Manager</h2>
        <p className="text-muted-foreground">
          Manage and monitor your sub-accounts
        </p>
      </div>
      {(isWhiteLabel && !canCreateSubAccounts && !isLoadingSubAccountCreation) && <SetupRequired />}
      <AccountsTable />
    </div>
      
  );
}

export default SubAccountsManager;